/* MP3 Email Gate v4.2 (copy refresh 2026-09-29) — Subscribe to Klaviyo to unlock MP3 downloads
 * Detects MP3 PWYW product pages and gates the buy button behind email subscription.
 * Uses Klaviyo Client API (no server needed).
 * Public API Key: SP4RpC
 *
 * v2: Also subscribes to DawnBringers list on every MP3 signup.
 * v3: After signup, free tier gets 1-click cart+checkout (no billing/CC for $0 digital).
 *     Paid tiers ($1-$10) revealed via "Support the Artist" toggle with normal checkout.
 * v4: FREE TIER BYPASSES CHECKOUT ENTIRELY — direct CDN download after email gate.
 *     Paid tiers ($1-$10) still use Shopify checkout.
 * v4.1: Fires "MP3 License Granted" Klaviyo event with unique auth code after signup.
 *       Klaviyo flow sends licensing authorization email automatically.
 */
(function() {
  var KLAVIYO_COMPANY_ID = 'SP4RpC';
  var DAWNBRINGERS_LIST_ID = 'RBrbXF';

  /* Product handle → Klaviyo list ID mapping */
  var PRODUCT_LISTS = {
    'wings-of-fate-songs-mp3-download': 'ULSeUc',
    'fire-flower-songs-mp3-download': 'SmriM6',
    'burden-of-the-crown-songs-mp3-download': 'UGeYyN'
  };

  /* Album display names */
  var PRODUCT_NAMES = {
    'wings-of-fate-songs-mp3-download': 'Wings of Fate',
    'fire-flower-songs-mp3-download': 'Fire Flower',
    'burden-of-the-crown-songs-mp3-download': 'Burden of the Crown'
  };

  /* Per-product free songs with direct CDN download URLs */
  var FREE_SONGS = {
    'wings-of-fate-songs-mp3-download': [
      { song: 'The Peace before the Storm', file: 'The-Peace-before-the-Storm.mp3' },
      { song: 'Repentance', file: 'Repentance.mp3' },
      { song: 'The Peace before the Storm (JP)', file: 'The-Peace-before-the-Storm-JP.mp3' },
      { song: 'The Forgotten Calling', file: 'The-Forgotten-Calling.mp3' },
      { song: 'Melt Just Like Ink', file: 'Melt-Just-Like-Ink.mp3' }
    ],
    'fire-flower-songs-mp3-download': [
      { song: 'Fire Flower', file: 'Fire-Flower.mp3' },
      { song: 'Under the Star Tonight', file: 'Under-the-Star-Tonight.mp3' }
    ],
    'burden-of-the-crown-songs-mp3-download': [
      { song: 'Ashes of the Oath', file: 'Ashes-of-the-Oath.mp3' },
      { song: 'Shooting Star', file: 'Shooting-Star.mp3' },
      { song: 'Addiction', file: 'Addiction.mp3' },
      { song: 'Sanctuary', file: 'Sanctuary.mp3' }
    ]
  };

  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0808/0287/3568/files/';

  /* Generate a unique authorization code: WOF-XXXX-XXXX */
  function generateAuthCode() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // no 0/O/1/I ambiguity
    var code = 'WOF-';
    for (var i = 0; i < 4; i++) code += chars.charAt(Math.floor(Math.random() * chars.length));
    code += '-';
    for (var j = 0; j < 4; j++) code += chars.charAt(Math.floor(Math.random() * chars.length));
    return code;
  }

  /* Fire "MP3 License Granted" event to Klaviyo — triggers authorization email flow */
  function trackLicenseEvent(email, authCode) {
    try {
      var songNames = (FREE_SONGS[handle] || []).map(function(s) { return s.song; });
      var payload = {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'MP3 License Granted' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: {
              authorization_code: authCode,
              album_name: albumName,
              product_handle: handle,
              songs: songNames,
              source: 'Shopify MP3 Email Gate v4'
            }
          }
        }
      };
      var xhr3 = new XMLHttpRequest();
      xhr3.open('POST', 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, true);
      xhr3.setRequestHeader('Content-Type', 'application/json');
      xhr3.setRequestHeader('revision', '2024-10-15');
      xhr3.send(JSON.stringify(payload));
    } catch(e) {
      console.warn('[MP3 Gate] License event tracking error:', e);
    }
  }

  /* Detect current product handle from URL */
  var path = window.location.pathname;
  var match = path.match(/\/products\/([^?#/]+)/);
  if (!match) return;
  var handle = match[1];
  if (!PRODUCT_LISTS[handle]) return;

  var listId = PRODUCT_LISTS[handle];
  var albumName = PRODUCT_NAMES[handle] || 'this album';
  var freeSongs = FREE_SONGS[handle] || [];
  var STORAGE_KEY = 'starlittunes_mp3_subscribed';

  /* Check if already subscribed */
  function isSubscribed() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return data[handle] === true;
    } catch(e) { return false; }
  }

  function markSubscribed() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      data[handle] = true;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch(e) {}
  }

  /* If already subscribed, show the free download UI immediately (no gate) */
  if (isSubscribed()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { injectFreeUI(null); });
    } else {
      injectFreeUI(null);
    }
    return;
  }

  /* Wait for DOM ready */
  function init() {
    var buyArea = document.querySelector('[data-block-type="buy-buttons"]')
      || document.querySelector('product-form')
      || document.querySelector('form[action*="/cart/add"]');

    if (!buyArea) {
      setTimeout(function() {
        buyArea = document.querySelector('[data-block-type="buy-buttons"]')
          || document.querySelector('product-form')
          || document.querySelector('form[action*="/cart/add"]');
        if (buyArea) setupGate(buyArea);
      }, 500);
      return;
    }
    setupGate(buyArea);
  }

  function setupGate(buyArea) {
    var variantBlocks = document.querySelectorAll(
      '[data-block-type="variant-picker"], [data-block-type="quantity"], .product-option, variant-picker'
    );

    /* Hide buy area and variants */
    buyArea.style.display = 'none';
    variantBlocks.forEach(function(el) { el.style.display = 'none'; });

    var stickyBar = document.querySelector('.product-sticky-add-to-cart, [data-sticky-add-to-cart]');
    if (stickyBar) stickyBar.style.display = 'none';

    /* Create the gate UI */
    var gate = document.createElement('div');
    gate.id = 'mp3EmailGate';
    gate.innerHTML = [
      '<div class="mp3-gate">',
      '  <div class="mp3-gate__icon">🎵✉️</div>',
      '  <div class="mp3-gate__title">Get the ' + albumName + ' songs, free</div>',
      '  <div class="mp3-gate__desc">Join the <strong>' + albumName + '</strong> mailing list to unlock free MP3 downloads and get updates on new songs.</div>',
      '  <div class="mp3-gate__form">',
      '    <input type="email" id="mp3GateEmail" class="mp3-gate__input" placeholder="Your email address" autocomplete="email" />',
      '    <button type="button" id="mp3GateBtn" class="mp3-gate__btn">Send me the songs 🦋</button>',
      '  </div>',
      '  <div id="mp3GateError" class="mp3-gate__error" style="display:none;"></div>',
      '  <div class="mp3-gate__fine">You will also get new songs and chapters by email the day they drop. Unsubscribe anytime.</div>',
      '</div>'
    ].join('\n');

    buyArea.parentNode.insertBefore(gate, buyArea);

    var emailInput = document.getElementById('mp3GateEmail');
    var submitBtn = document.getElementById('mp3GateBtn');
    var errorDiv = document.getElementById('mp3GateError');

    emailInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); submitBtn.click(); }
    });

    submitBtn.addEventListener('click', function() {
      var email = emailInput.value.trim();
      if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        errorDiv.textContent = 'Please enter a valid email address.';
        errorDiv.style.display = 'block';
        emailInput.focus();
        return;
      }
      errorDiv.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = '🦋 Subscribing...';

      function buildPayload(targetListId, source, extraProps) {
        var props = {
          'MP3 Signup Source': 'Shopify Product Page',
          'MP3 Album': albumName,
          'MP3 Signup Date': new Date().toISOString()
        };
        if (extraProps) {
          for (var k in extraProps) { props[k] = extraProps[k]; }
        }
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: props
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: targetListId } }
            }
          }
        };
      }

      var albumPayload = buildPayload(listId, 'MP3 Download Gate — ' + albumName, {});

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('revision', '2024-10-15');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 202) {
          subscribeToDawnBringers(email);
          var authCode = generateAuthCode();
          trackLicenseEvent(email, authCode);
          onSuccess(gate, buyArea, variantBlocks, stickyBar, email);
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send me the songs 🦋';
          errorDiv.textContent = 'Something went wrong. Please try again.';
          errorDiv.style.display = 'block';
          console.warn('[MP3 Gate] Klaviyo error:', xhr.status, xhr.responseText);
        }
      };
      xhr.onerror = function() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send me the songs 🦋';
        errorDiv.textContent = 'Network error. Please check your connection.';
        errorDiv.style.display = 'block';
      };
      xhr.send(JSON.stringify(albumPayload));
    });
  }

  /* Fire-and-forget subscription to DawnBringers list */
  function subscribeToDawnBringers(email) {
    try {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'MP3 Download Gate — Auto DawnBringers',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'MP3 Signup Source': 'Shopify Product Page',
                    'MP3 Album': (PRODUCT_NAMES[window.location.pathname.match(/\/products\/([^?#/]+)/)[1]] || 'Unknown'),
                    'DawnBringers Source': 'MP3 Download Gate'
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: DAWNBRINGERS_LIST_ID } }
          }
        }
      };
      var xhr2 = new XMLHttpRequest();
      xhr2.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, true);
      xhr2.setRequestHeader('Content-Type', 'application/json');
      xhr2.setRequestHeader('revision', '2024-10-15');
      xhr2.send(JSON.stringify(payload));
    } catch(e) {
      console.warn('[MP3 Gate] DawnBringers subscription error:', e);
    }
  }

  function onSuccess(gate, buyArea, variantBlocks, stickyBar, email) {
    markSubscribed();

    /* Animate gate out */
    gate.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
    gate.style.opacity = '0';
    gate.style.transform = 'translateY(-10px)';

    setTimeout(function() {
      gate.remove();
      injectFreeUI(email, buyArea, variantBlocks, stickyBar);
    }, 400);
  }

  /* ── v4: Direct download UI — no checkout for free tier ── */
  function injectFreeUI(email, buyArea, variantBlocks, stickyBar) {
    /* If called from isSubscribed() (returning visitor), find the buy elements */
    if (!buyArea) {
      buyArea = document.querySelector('[data-block-type="buy-buttons"]')
        || document.querySelector('product-form')
        || document.querySelector('form[action*="/cart/add"]');
      if (!buyArea) {
        setTimeout(function() { injectFreeUI(email); }, 500);
        return;
      }
      variantBlocks = document.querySelectorAll(
        '[data-block-type="variant-picker"], [data-block-type="quantity"], .product-option, variant-picker'
      );
      stickyBar = document.querySelector('.product-sticky-add-to-cart, [data-sticky-add-to-cart]');
    }

    /* Hide original buy UI (we replace it) */
    buyArea.style.display = 'none';
    variantBlocks.forEach(function(el) { el.style.display = 'none'; });
    if (stickyBar) stickyBar.style.display = 'none';

    /* Build song list HTML — direct download buttons */
    var songButtons = freeSongs.map(function(s) {
      return '<button class="mp3-free__song-btn" data-file="' + s.file + '" data-song="' + s.song + '">' +
        '<span class="mp3-free__song-icon">🎵</span>' +
        '<span class="mp3-free__song-name">' + s.song + '</span>' +
        '<span class="mp3-free__song-arrow">↓ Free</span>' +
        '</button>';
    }).join('\n');

    var panel = document.createElement('div');
    panel.id = 'mp3FreePanel';
    panel.innerHTML = [
      '<div class="mp3-free">',
      '  <div class="mp3-free__header">',
      '    <div class="mp3-free__check">✅</div>',
      '    <div class="mp3-free__title">You\'re In! Pick Your Songs</div>',
      '    <div class="mp3-free__subtitle">Tap a song to download it instantly — no checkout, no waiting.</div>',
      '  </div>',
      '  <div class="mp3-free__songs">',
           songButtons,
      '  </div>',
      '  <div id="mp3FreeStatus" class="mp3-free__status" style="display:none;"></div>',
      '  <div class="mp3-free__divider"></div>',
      '  <button id="mp3SupportToggle" class="mp3-free__support-toggle">',
      '    ❤️ Want to support the artist? ($1 – $10)',
      '  </button>',
      '  <div id="mp3SupportArea" class="mp3-free__support-area" style="display:none;"></div>',
      '</div>'
    ].join('\n');

    buyArea.parentNode.insertBefore(panel, buyArea);

    /* Animate in */
    panel.style.opacity = '0';
    panel.style.transition = 'opacity 0.5s ease';
    setTimeout(function() { panel.style.opacity = '1'; }, 50);

    /* Wire up free download buttons — direct CDN download */
    var songBtns = panel.querySelectorAll('.mp3-free__song-btn');
    var statusDiv = document.getElementById('mp3FreeStatus');

    songBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fileName = btn.getAttribute('data-file');
        var songName = btn.getAttribute('data-song');
        var downloadUrl = CDN_BASE + fileName;

        btn.classList.add('mp3-free__song-btn--loading');
        btn.querySelector('.mp3-free__song-arrow').textContent = '⏳';
        statusDiv.textContent = '⬇️ Downloading "' + songName + '"...';
        statusDiv.style.display = 'block';

        /* Fetch as blob to force browser download (cross-origin CDN) */
        fetch(downloadUrl)
          .then(function(resp) {
            if (!resp.ok) throw new Error('Download failed: ' + resp.status);
            return resp.blob();
          })
          .then(function(blob) {
            var blobUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = blobUrl;
            a.download = songName + '.mp3';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function() { URL.revokeObjectURL(blobUrl); }, 5000);

            btn.classList.remove('mp3-free__song-btn--loading');
            btn.classList.add('mp3-free__song-btn--done');
            btn.querySelector('.mp3-free__song-arrow').textContent = '✓ Done';
            statusDiv.textContent = '🎉 "' + songName + '" downloaded! Enjoy the music.';
          })
          .catch(function(err) {
            console.error('[MP3 Free] Download error:', err);
            /* Fallback: open URL in new tab */
            window.open(downloadUrl, '_blank');
            btn.classList.remove('mp3-free__song-btn--loading');
            btn.querySelector('.mp3-free__song-arrow').textContent = '↓ Free';
            statusDiv.textContent = '📎 Download opened in a new tab.';
            statusDiv.style.display = 'block';
          });
      });
    });

    /* Wire up support toggle → reveal original buy UI */
    var supportToggle = document.getElementById('mp3SupportToggle');
    var supportArea = document.getElementById('mp3SupportArea');

    supportToggle.addEventListener('click', function() {
      if (supportArea.style.display === 'none') {
        supportArea.style.display = 'block';
        supportToggle.textContent = '▾ Hide support options';

        /* Move original buy area + variant pickers into support area */
        buyArea.style.display = '';
        buyArea.style.opacity = '1';
        variantBlocks.forEach(function(el) {
          el.style.display = '';
          el.style.opacity = '1';
        });
        if (stickyBar) stickyBar.style.display = '';
        supportArea.appendChild(buyArea);
        variantBlocks.forEach(function(el) { supportArea.appendChild(el); });
      } else {
        supportArea.style.display = 'none';
        supportToggle.textContent = '❤️ Want to support the artist? ($1 – $10)';
        buyArea.style.display = 'none';
        variantBlocks.forEach(function(el) { el.style.display = 'none'; });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
